import { isBrowser } from './is-browser';
export const imperativeChangeInputValue = (ref, event, value) => {
  if (ref != null && ref.current) {
    event.stopPropagation();
    if (isBrowser()) {
      var _Object$getOwnPropert, _Object$getOwnPropert2;
      (_Object$getOwnPropert = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')) == null ? void 0 : (_Object$getOwnPropert2 = _Object$getOwnPropert.set) == null ? void 0 : _Object$getOwnPropert2.call(ref.current, value);
    }
    ref.current.dispatchEvent(new Event('input', {
      bubbles: true,
      cancelable: true
    }));
  }
};